'use client';

import React, { forwardRef, useMemo } from 'react';
import { NativeSelect as Select } from '@chakra-ui/react';

interface NativeSelectRootProps extends Select.RootProps {
  icon?: React.ReactNode;
}

export const NativeSelectRoot = forwardRef<HTMLDivElement, NativeSelectRootProps>((props, ref) => {
  const { icon, children, ...rest } = props;
  return (
    <Select.Root ref={ref} {...rest}>
      {children}
      <Select.Indicator>{icon}</Select.Indicator>
    </Select.Root>
  );
});

interface NativeSelectItem {
  value: string;
  label: string;
  disabled?: boolean;
}

interface NativeSelectFieldType extends Select.FieldProps {
  items?: Array<string | NativeSelectItem>;
  fieldBg?: string;
}

export const NativeSelectField = forwardRef<HTMLSelectElement, NativeSelectFieldType>((props, ref) => {
  const { items: itemsProp, children, fieldBg, placeholder, style, ...rest } = props;

  const items = useMemo(
    () => itemsProp?.map((item) => (typeof item === 'string' ? { label: item, value: item } : item)),
    [itemsProp]
  );

  return (
    <Select.Field
      ref={ref}
      style={
        fieldBg
          ? ({ ...style, '--eezi-native-select-bg': `var(--chakra-colors-${fieldBg})` } as React.CSSProperties)
          : style
      }
      {...rest}
    >
      {placeholder && (
        <option value='' hidden>
          {placeholder}
        </option>
      )}
      {children}
      {items?.map((item) => (
        <option key={item.value} value={item.value} disabled={item.disabled}>
          {item.label}
        </option>
      ))}
    </Select.Field>
  );
});
